export const DOT = ',';
